<h3-page-loading-overlay *ngIf="isLoading$ | async"></h3-page-loading-overlay>
<ng-container #container></ng-container>
